<template>
    <div class="inside_pages_right">
        <div class="inside_pages_right_top">
           <div class="inside_header_title">公共安全课堂库</div>
        </div>
        <div class="inside_pages_right_content">
            <div class="inside_pages_right_content_top ">
                <div class="inside_pages_right_content_top_left ">
                    <el-cascader :options="cateList" :props="{ expandTrigger:'hover'}" size="mini">
                        <template slot-scope="{ node, data }">
                            <span>{{ data.label }}</span>
                            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
                        </template>
                    </el-cascader>
                </div>
                <div class="inside_pages_right_content_top_right ">
                    <el-input v-model.trim="requestData.title"  size="mini" placeholder="请输入课堂名称"></el-input> &nbsp;
                    <el-button size="mini" type="primary" plain icon="el-icon-search">搜索</el-button>
                </div>
            </div>
            <div class="inside_pages_right_content_center">
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">
                    <el-table-column prop="id" label="ID">
                    </el-table-column>

                    <el-table-column prop="name" label="课堂名称">
                    </el-table-column>

                    <el-table-column prop="img" label="封面图">
                        <template slot-scope="scope">
                            <el-image  class="img-thumbnail"
                                :src="$store.state.config.fileUrl+scope.row.img" 
                                :preview-src-list="[$store.state.config.fileUrl+scope.row.img]">
                            </el-image>
                        </template>
                    </el-table-column>

                    <el-table-column prop="class1" label="年级分类">
                    </el-table-column>

                    <el-table-column prop="class2" label="课堂类别">
                    </el-table-column>

                    <el-table-column prop="date" label="创建时间">
                    </el-table-column>

                    <el-table-column  label="操作">
                        <template slot-scope="scope">
                            <el-button  type="primary" plain  size="mini"   icon="el-icon-document">
                                预览
                            </el-button>
                            <el-button  type="primary" plain  size="mini"   icon="el-icon-data-analysis" >
                                使用统计
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="inside_pages_right_content_bottom">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'',
    components: {},
    props: {},
    data() {
        return {
             requestData:{
                pageNum:1,
                pageSize:20,
                fileClassification:'',
                title:'',
            },
            // 数据列表
            responseData: {
                pageNum:1,        // 第几页
                pageSize:20,      // 一页多少个
                total:0,      // 总条数
                pages:0,     // 总页数
                list:[
                     {
                        id:123,
                        name: '王小虎',
                        date: '2016-05-03',
                        img:'images/20200522/e51881bb28964b748b1677c780036b21.png',
                        class1:'小学低年级',
                        class2:'心理健康-学习态度',
                    }, 
                     {
                        id:123,
                        name: '王小虎',
                        date: '2016-05-03',
                        img:'images/20200522/e51881bb28964b748b1677c780036b21.png',
                        class1:'小学低年级',
                        class2:'心理健康-学习态度',
                    }, 
                ],       // 数据列表
            },
            cateList:[],

            thisPages:1,

            cateList:[],
            

        };
    },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },
        // 获取类别
        async getCate(){
			var newParamData = {
                schoolId:this.$store.state.schoolId,
            }
			let res = await  this.$Http.getResourceClassification(newParamData,true)
			if(res.code == 200){
                if(res.data.length>=1){
                    this.cateList = []
                    for(var keyOne in res.data){
                        var sonDataList = []
                        for(var keyTwo in res.data[keyOne].resourceClassificationLists){
                            sonDataList.push({
                                value: keyOne + '-' + keyTwo,
                                label: res.data[keyOne].resourceClassificationLists[keyTwo].subclassificationName,
                                thisId: res.data[keyOne].resourceClassificationLists[keyTwo].id,
                                thisLevel: 2,
                            })
                        }
                        this.cateList.push({
                            value: keyOne,
                            label: res.data[keyOne].fatherNode,
                            thisId: res.data[keyOne].id,
                            thisLevel: 1,
                            children:sonDataList,
                        })
                    }
                }
                // console.log(this.cateList)
            }else if(res.code == 101){

            } else {
                this.$message({
                    type: 'error',
                    message: res.messsage
                });
            }
        },
        
    },
    created() {},
    mounted() {
        this.getCate()
    }
};
</script>